import {yupResolver} from "@hookform/resolvers/yup";
import {FormProvider, useForm} from "react-hook-form";
import {
  renameUserScheduleFormValidationSchema,
  RenameUserScheduleFormValues,
} from "./schema-validation";
import {UserScheduleNameFormField} from "./form-fields/schedule-name";
import {Button, Modal, Space} from "antd";
import {StyledModalContentWrapper} from "../../../../../../components/calls/upcoming-calls/call-card/call-card.style";
import {useRenameUserScheduleHook} from "../../hooks/rename-user-schedule";
import {useCallback} from "react";

export type RenameScheduleFormModalProps = {
  handleRenameScheduleModalOk(): void;
  handleCloseRenameScheduleModal(): void;
  isRenameScheduleModalOpen: boolean;
  scheduleId: string;
  scheduleName: string;
};

export function RenameScheduleFormModal({
  handleCloseRenameScheduleModal,
  isRenameScheduleModalOpen,
  scheduleId,
  scheduleName,
}: RenameScheduleFormModalProps) {
  const formMethods = useForm<RenameUserScheduleFormValues>({
    resolver: yupResolver(renameUserScheduleFormValidationSchema),
    mode: "onChange",
    defaultValues: {
      scheduleName: scheduleName,
    },
  });

  const closeModalWIthoutFormReset = useCallback(() => {
    handleCloseRenameScheduleModal();
  }, [handleCloseRenameScheduleModal]);

  const {renameUserSchedule, isRenamingUserSchedule, wasUserScheduleRenamed} =
    useRenameUserScheduleHook({
      closeModal: closeModalWIthoutFormReset,
    });

  function closeModal() {
    if (!wasUserScheduleRenamed) {
      formMethods.reset();
    }
    handleCloseRenameScheduleModal();
  }

  function onSubmit(values: RenameUserScheduleFormValues) {
    console.log({values});
    renameUserSchedule({...values, scheduleId});
  }
  return (
    <Modal
      visible={isRenameScheduleModalOpen}
      title={"Rename new schedule"}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
      centered
    >
      <StyledModalContentWrapper>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)} autoComplete="off">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <UserScheduleNameFormField />
              <div style={{display: "flex", justifyContent: "end"}}>
                <Space size={16} direction="horizontal" style={{display: "flex"}}>
                  <Button size="small" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    type="primary"
                    htmlType="submit"
                    loading={isRenamingUserSchedule}
                  >
                    Save
                  </Button>
                </Space>
              </div>
            </Space>
          </form>
        </FormProvider>
      </StyledModalContentWrapper>
    </Modal>
  );
}
